import {Brochure, BrochureDisplay} from "@/types/dto/common/brochure";
import imageFactory from "@/factories/common/image-factory";
import boolify from "@/factories/utils/boolify";

export const brochureFactory = (data?: any): Brochure => ({
  brochureNameAndYear: data?.brochureNameAndYear ?? "",
  brochureName: data?.brochureName ?? "",
  brochureDescription: data?.brochureDescription ?? "",
  productYear: data?.productYear ?? "",
  image: imageFactory(data?.image),
  destinationContinent: Array.isArray(data?.destinationContinent) ? data?.destinationContinent : [],
  destinationCountries: Array.isArray(data?.destinationCountries) ? data?.destinationCountries :  [],
  brochureCode: data?.brochureCode ?? "",
  viewLink: data?.viewLink ?? "",
  pdfDownloadLink: data?.pdfDownloadLink ?? "",
  brochureIsOrderable: boolify(data?.brochureIsOrderable),
  audience: data?.audience ?? ""
});

const brochureDisplayFactory = (data?: any): BrochureDisplay => ({
  minimumOrder: data?.minimumOrder ?? 1,
  maximumOrder: data?.maximumOrder ?? 1,
  brochureOrder: Array.isArray(data?.brochureOrder) ? data?.brochureOrder.map(brochureFactory) : [],
  preselectedBrochure: data?.preselectedBrochure ? brochureFactory(data.preselectedBrochure) : undefined
});



export default brochureDisplayFactory;